import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'gatsby';
import sysi_logo from '../images/sysi_logo.jpg';
import influencer_logo from '../images/influencer_logo.jpg';
import achieve_logo from '../images/a-chieve_logo.jpg';
import doplus_logo from '../images/doplus_logo.jpg';
import newgeneration_logo from '../images/new-generation_logo.jpg';


export const supports = [
  {
    icon: <FontAwesomeIcon icon={['fad', 'hands-usd']} />,
    title: 'เงินทุน • FUNDING',
    content: (
      <>
        เข้าถึงเงินทุนสําหรับสนับสนุนการทําโครงการไปจนถึงการก่อตั้งองค์กร<br />
        ตั้งแต่ระดับสูงสุด 20,000 บาท<br />
        สูงสุด 50,000 บาท และสูงสุด 650,000 บาท
      </>
    ),
  },
  {
    icon: <FontAwesomeIcon icon={['fad', 'book-spells']} />,
    title: 'ทักษะ • TRAINING',
    content:
      'พัฒนาความรู้และทักษะที่จําเป็นต่อการพัฒนาตนเอง พัฒนาทีม และพัฒนาโครงการ ไม่ว่าจะเป็นวิธีคิด เครื่องมือ ความรู้ทางสังคม และการบริหารโครงการ',
  },
  {
    icon: <FontAwesomeIcon icon={['fad', 'monitor-heart-rate']} />,
    title: 'ติดตาม • MONITORING',
    content:
      'ลงพื้นที่ติดตามและให้คําปรึกษาแต่ละโครงการ สนับสนุนการเติบโตทั้งระดับบุคคล ระดับทีม และการสร้างผลกระทบของโครงการ',
  },
  {
    icon: <FontAwesomeIcon icon={['fad', 'chart-network']} />,
    title: 'เครือข่าย • NETWORK',
    content: (
      <>
        เส้นทางการสร้างการเปลี่ยนแปลงทางสังคมจะไปได้ยาวถ้าไปด้วยกัน<br />ที่นี่สนับสนุนการเรียนรู้ร่วมกันอย่างเข้มข้นระหว่างเพื่อนร่วมรุ่น
      </>
    ),
  },
];

export const levels = [
  styles => ({
    title: 'Rookie • ระดับเริ่มต้น',
    content: (
      <>
        <h4 className={styles.content}>
          สําหรับผู้ที่มีไอเดียในการแก้ปัญหาสังคมที่ตนเองพบเจอ
          และอยากจะทดลองทําเพื่อแก้ปัญหานั้นให้ได้
        </h4>
        • อายุระหว่าง 15-25 ปี
        <br />
        • จํานวนสมาชิก 1-3 คน
        <br />
        • ระยะเวลาทําโครงการ 4 เดือน
        <br />• ทุนสนับสนุนสูงสุด 20,000 บาท
      </>
    ),
    actions : [
      {
        label: 'อ่านรายละเอียด',
        color:'#ECEFF1',
        variant: 'contained',
        component: Link,
        to: '/courses/rookie',
      },
    ],
    // actions: [
    //   {
    //     label: 'สมัครเข้าร่วม',
    //     variant: 'containedPrimary',
    //     component: Link,
    //     to: 'https://docs.google.com/forms/d/e/1FAIpQLSdqiBObqcaao36rYOu-FPqRmWfS7ymSw0ohCeliNHA-igEz_Q/viewform',
    //   },
    // ],
  }),
  styles => ({
    title: 'Pre-Turn Pro • ระดับพัฒนา',
    // extra: 'เปิดรับสมัครแล้ว ถึง 9 ต.ค. 63',
    content: (
      <>
        <h4 className={styles.content}>
          สําหรับกลุ่มที่ต้องการขยับขยายให้สิ่งที่ทําสร้างผลกระทบทางสังคมมากขึ้น
          จริงจังมากขึ้น
        </h4>
        • อายุระหว่าง 18-30 ปี
        <br />
        • จํานวนสมาชิก 2-5 คน
        <br />
        • ระยะเวลาทําโครงการ 5 เดือน
        <br />• ทุนสนับสนุนสูงสุด 50,000 บาท
      </>
    ),
    // actions: [
    //   // {
    //   //   id: 'download-app-form-turn-pro',
    //   //   label: 'โหลดใบสมัคร',
    //   //   variant: 'contained',
    //   //   color: 'primary',
    //   //   component: 'a',
    //   //   href:
    //   //     'https://docs.google.com/forms/d/e/1FAIpQLSdV33l4c8_FjST-lA0q0rOIIue93_nxOHt7ks1C7RtbKFEY2w/viewform',
    //   //   target: '_blank',
    //   //   rel: 'noopener',
    //   // },
    //   {
    //     label: 'อ่านรายละเอียด',
    //     variant: 'contained',
    //     component: Link,
    //     to: '/courses/semi-pro',
    //   },
    // ],
    actions: [
      {
        label: 'สมัครเข้าร่วม',
        variant: 'containedPrimary',
        component: Link,
        to: 'https://docs.google.com/forms/d/e/1FAIpQLScZsDoXCPVFZxkJxhQgTAilfnIhS1SYLkjkg3f-0Qo49rR-pA/viewform',
      },
    ],
  }),
  styles => ({
    title: 'Turn Pro • ระดับผู้เชี่ยวชาญ',
    content: (
      <>
        <h4 className={styles.content}>
          สําหรับกลุ่มที่ผ่านระดับ Pre-Turn Pro มาก่อน ต้องการจริงจังกับการแก้ปัญหาในประเด็นที่ทําและต้องการการสนับสนุน
          เพื่อสร้างองค์กรของตนเองสําหรับทํางานต่อในระยะยาว
        </h4>
        • อายุระหว่าง 18-30 ปี
        <br />
        • จํานวนสมาชิก 2-5 คน
        <br />
        • ระยะเวลาทําโครงการ 9 เดือน
        <br />• ทุนสนับสนุนสูงสุด 650,000 บาท
      </>
    ),
    actions: [
      {
        label: 'อ่านรายละเอียด',
        variant: 'contained',
        component: Link,
        to: '/courses/turn-pro',
      },
    ],
  }),
];

export const doodles = [
  {
    alt: 'doodle A',
    fileName: 'doodle-A',
    label: <>มีศักยภาพ<br />และความมุ่งมั่น</>,
  },
  {
    alt: 'doodle B',
    fileName: 'doodle-B',
    label: 'พร้อมที่จะเรียนรู้ร่วมกับเพื่อนอย่างเข้มข้น',
  },
  {
    alt: 'doodle C',
    fileName: 'doodle-C',
    label: <>แก้ปัญหาตรงจุด<br />และเป็นไปได้</>,
  },
  {
    alt: 'doodle D',
    fileName: 'doodle-D',
    label: 'สร้างสรรค์ คิดการใหญ่',
  },
  {
    alt: 'doodle E',
    fileName: 'doodle-E',
    label: <>เห็นโอกาสเติบโต<br />สร้างผลกระทบทางสังคมเพิ่ม</>,
  },
  {
    alt: 'doodle F',
    fileName: 'doodle-F',
    label: <>เกิดผลยั่งยืน<br />กับกลุ่มเป้าหมาย</>,
  },
];

export const logos = [
  { alt: 'sysi logo', src: sysi_logo },
  { alt: 'new generation logo', src: newgeneration_logo },
  { alt: 'achieve logo', src: achieve_logo },
  { alt: 'influencer logo', src: influencer_logo },



];
